import React from "react";
import "./Watch_button.css";

function Watch_button() {
  return (
    <div>
      <div className="Watch_button">
        <button className="Watchbtn">Watch Latest Episode</button>
      </div>
    </div>
  );
}

export default Watch_button;
